import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type GetBettieEnergiesResponse = NonNullable<
  paths['/api/v1/bettie_energies/me']['get']['responses'][200]['content']['application/json']['bettieEnergy']
>;

export type ConvertBettieEnergiesResponse = NonNullable<
  paths['/api/v1/bettie_energies/convert']['post']['responses'][200]['content']['application/json']['bettieEnergy']
>;

export async function getBettieEnergies(): Promise<GetBettieEnergiesResponse> {
  const { data, error } = await client.GET('/api/v1/bettie_energies/me', {
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response from getBettieEnergies');
  return data.bettieEnergy;
}

export async function convertBettieEnergies(): Promise<ConvertBettieEnergiesResponse> {
  const { data, error } = await client.POST('/api/v1/bettie_energies/convert', {
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response from convertBettieEnergies');
  return data.bettieEnergy;
}
